<template>
	<div>
		<h1 v-text="isCompany ? '내사업관리' : '내사업관리'">내사업관리</h1>
		<div class="search-bar web-hide">
			<input placeholder="검색" v-model="keyword" v-on:keyup.enter="searchKeyword" />
		</div>
		<div class="basic-container">
			<div>
				<div class="tool-box mobile-hide">
					<div class="search-bar">
						<input placeholder="검색" v-model="keyword" v-on:keyup.enter="searchKeyword" />
					</div>
					<div class="selectbox-area mobile-hide">
						<div class="select-wrapper cols-middle-tp">
							<select v-model="businessYear">
								<option value="0">사업연도</option>
								<option v-for="(codeVO, i) in groupByBusinessYearList" :key="'groupByBusinessYearList_' + i" :value="codeVO.businessYear"
									>{{ codeVO.businessYear }}년</option
								>
							</select>
						</div>
						<div class="select-wrapper cols-middle-tp" v-if="!isCompany">
							<select v-model="businessTp">
								<option value="" selected>소속TP</option>
								<option v-for="(codeVO, i) in businessYearByTpList" :key="'businessYearByTpList_' + i" :value="codeVO.businessTp"
									>{{ codeVO.businessTpNm }}TP</option
								>
							</select>
						</div>
						<div class="select-wrapper cols-long" v-if="isCompany">
							<select v-model="country">
								<option value="" selected>국가</option>
								<option v-for="(codeVO, i) in countryList" :key="'countryList_' + i" :value="codeVO.country">{{ codeVO.countryNm }}</option>
							</select>
						</div>
						<div class="select-wrapper cols-long" v-if="isCompany">
							<select v-model="region">
								<option value="" selected>지회</option>
								<option v-for="(codeVO, i) in regionList" :key="'regionList' + i" :value="codeVO.region">{{ codeVO.regionNm }}</option>
							</select>
						</div>
					</div>
				</div>
				<section class="table-area">
					<div class="table-header mobile-hide" ref="table">
						<div class="col-no">번호</div>
						<div class="col-date">연도</div>
						<div class="col-date" v-if="!isCompany">소속TP</div>
						<div class="col-date" v-if="!isCompany">사업차수</div>
						<div class="col-state" v-if="isCompany">국가</div>
						<div class="col-state" v-if="isCompany">지회</div>
						<div class="col-state" v-text="isCompany ? '회원명' : '새싹기업명'">새싹기업명</div>
						<div class="col-state" v-if="!isCompany">사업자등록번호</div>
						<div class="col-state">승인상태</div>
						<div class="col-auto">협약기간</div>
					</div>
					<!--   web   -->
					<article class="table-list mobile-hide" v-for="(businessVO, i) in businessList" v-bind:key="'businessList_web_' + i">
						<div class="col-no mobile-hide">{{ totalCount - (listPage - 1) * listPageRow - i }}</div>
						<div class="col-date">{{ businessVO.businessYear }}</div>
						<div class="col-date" v-if="!isCompany">
							<a @click="moveDetail(businessVO.matchSeqNo)">
								{{ businessVO.businessTpNm !== null || businessVO.businessTpNm !== '' ? businessVO.businessTpNm + 'TP' : '-' }}
							</a>
						</div>
						<div class="col-date" v-if="!isCompany">
							<a @click="moveDetail(businessVO.matchSeqNo)">
								{{ businessVO.businessMainStep !== null || businessVO.businessMainStep !== '' ? businessVO.businessMainStep + '차' : '-' }}
							</a>
						</div>
						<div class="col-state" v-if="isCompany">
							<a @click="moveDetail(businessVO.matchSeqNo)">
								{{ businessVO.countryNm }}
							</a>
						</div>
						<div class="col-state font-bold" v-if="isCompany">
							<a @click="moveDetail(businessVO.matchSeqNo)">
								{{ businessVO.regionNm }}
							</a>
						</div>
						<div class="col-state">
							<a @click="moveDetail(businessVO.matchSeqNo)">
								<v-clamp :max-lines="1" autoresize :expanded="isTableResize" v-text="!isCompany ? businessVO.companyNmKor : businessVO.oktaUserNmKor"
									>기업명/마케터명</v-clamp
								>
							</a>
						</div>
						<div class="col-state mobile-hide" v-if="!isCompany">
							<a @click="moveDetail(businessVO.matchSeqNo)">
								{{ businessVO.registrationNo ? businessVO.registrationNo.replace(/(\d{3})(\d{2})(\d{5})/, '$1-$2-$3') : '' }}
							</a>
						</div>
						<div class="col-state font-bold">
							<span v-if="businessVO.finalPlanState === 'NOT_APPROVE'" class="color-red">미승인</span>
							<span v-else-if="businessVO.finalPlanState === 'STANDBY'" class="color-yellow">승인대기</span>
							<span v-else-if="businessVO.finalPlanState === 'APPROVE'" class="color-blue">승인완료</span>
							<span v-else class="color-shineGray">미등록</span>
						</div>
						<div class="col-auto">
							<span v-if="businessVO.agreementStartDate !== null">
								{{ $moment(businessVO.agreementStartDate).format('YY-MM-DD') }} ~ {{ $moment(businessVO.agreementEndDate).format('YY-MM-DD') }}
								<!--								{{ businessVO.agreementStartDate }} ~ {{ businessVO.agreementEndDate }}-->
							</span>
							<span v-if="businessVO.agreementStartDate === null"> - </span>
						</div>
					</article>
					<!--   mobile   -->
					<article class="table-list web-hide" v-for="(businessVO, i) in businessList" v-bind:key="'businessList_mobile_' + i">
						<div class="col-no mobile-hide">{{ totalCount - (listPage - 1) * listPageRow - i }}</div>
						<div class="col-title">
							<a @click="moveDetail(businessVO.matchSeqNo)">
								<v-clamp :max-lines="1" autoresize :expanded="isTableResize" v-text="!isCompany ? businessVO.companyNmKor : businessVO.oktaUserNmKor"
									>기업명/마케터명</v-clamp
								>
							</a>
						</div>
						<div class="col-date col-line">
							<a @click="moveDetail(businessVO.matchSeqNo)">
								{{ businessVO.businessYear }}
							</a>
						</div>
						<div class="col-date col-line" v-if="isCompany">
							<a @click="moveDetail(businessVO.matchSeqNo)">{{ businessVO.countryNm }}</a>
						</div>
						<div class="col-auto" v-if="isCompany">
							<a @click="moveDetail(businessVO.matchSeqNo)">{{ businessVO.regionNm }}</a>
						</div>
						<div class="col-date col-line" v-if="!isCompany">
							<a @click="moveDetail(businessVO.matchSeqNo)">
								{{ businessVO.businessTpNm !== null || businessVO.businessTpNm !== '' ? businessVO.businessTpNm + 'TP' : '-' }}
							</a>
						</div>
						<div class="col-auto" v-if="!isCompany">
							<a @click="moveDetail(businessVO.matchSeqNo)">
								{{ businessVO.businessMainStep !== null || businessVO.businessMainStep !== '' ? businessVO.businessMainStep + '차' : '-' }}
							</a>
						</div>
						<div class="col-auto mobile-hide" v-if="!isCompany">{{ businessVO.registrationNo }}</div>
						<span v-if="businessVO.agreementStartDate !== null" class="mobile-hide">
							{{ $moment(businessVO.agreementStartDate).format('YY-MM-DD') }} ~ {{ $moment(businessVO.agreementEndDate).format('YY-MM-DD') }}
						</span>
						<span v-if="businessVO.agreementStartDate === null" class="mobile-hide"> - </span>
						<div class="col-state font-bold">
							<span v-if="businessVO.finalPlanState === 'NOT_APPROVE'" class="color-red">미승인</span>
							<span v-else-if="businessVO.finalPlanState === 'STANDBY'" class="color-yellow">승인대기</span>
							<span v-else-if="businessVO.finalPlanState === 'APPROVE'" class="color-blue">승인완료</span>
							<span v-else class="color-shineGray">미등록</span>
						</div>
					</article>
				</section>
				<paging :total-count="totalCount" :page="listPage" :rows="listPageRow" :click="pageClick" />
			</div>
		</div>
	</div>
</template>

<script>
import CONST from '@/constants';
import Paging from '@/components/common/Paging';
import eventBus from '@/plugins/event-bus';
import moment from 'moment-timezone';

export default {
	title: '내비즈니스메인',
	name: 'MybusnessMain',
	props: ['viewType'],
	components: { Paging },
	data: function() {
		return {
			select: 1,
			isTableResize: false,
			colAutoWidth: 0,
			modalShow: false,
			CONST,
			loginMember: null,

			businessYear: 0,
			businessTp: '',
			country: '',
			region: '',
			keyword: '',

			listPage: 1,
			listPageRow: 10,
			totalCount: 0,
			groupByBusinessYearList: [],
			businessYearByTpList: [],
			countryList: [],
			regionList: [],
			businessList: [],
		};
	},
	watch: {
		businessYear: function() {
			// this.getBusinessYearByTpList();
			this.getBusinessList();
		},
		businessTp: function() {
			this.getBusinessList();
		},
		country: function() {
			this.getGroupByRegionList();
			this.getBusinessList();
		},
		region: function() {
			this.getBusinessList();
		},
	},
	created() {},
	mounted() {
		let dt = this.$device.loadLocalData('LOGIN_USER');
		if (dt) this.loginMember = JSON.parse(dt);
		// this.businessYear = this.$moment().format('YYYY');
		this.getGroupByBusinessYearList();
		this.getBusinessYearByTpList();
		this.getGroupByCountryList();
		this.getBusinessList();
		this.$device.sendEvent(CONST.EVENTS.SET_SIDE_MENU, 'BIZ');
		// window.onresize = this.onTableResize.bind(this);
		// this.onTableResize();
	},
	beforeDestroy() {
		window.onresize = null;
	},
	computed: {
		isCompany: function() {
			return this.loginMember && this.loginMember.budsUserType === CONST.USER_TYPE.COMPANY;
		},
	},
	methods: {
		moveDetail: function(seqNo, approveFCd) {
			//TODO 임시해제
			if (!this.isCompany && approveFCd === 'STANDBY') {
				alert('관리자 승인이 필요합니다.');
				return false;
			}
			this.$device.pushView('/mybusiness/detail/' + seqNo);
		},
		openModal: function(e) {
			let param = { matchSeqNo: e.target.id };
			eventBus.$emit(CONST.EVENTS.OPEN_MODAL, 'modalComplain', '민원', param);
		},
		notModal: function() {
			alert('접수된 민원이 없습니다.');
			return false;
		},

		searchKeyword: function() {
			this.listPage = 1;
			this.getBusinessList();
		},
		pageClick: function(p) {
			this.listPage = p;
			this.getBusinessList();
		},
		// 년도 불러오기
		getGroupByBusinessYearList: function() {
			let formData = new FormData();
			if (this.loginMember.budsUserType === CONST.USER_TYPE.COMPANY) {
				formData.append('companySeqNo', this.loginMember.seqNo);
			} else {
				formData.append('userSeqNo', this.loginMember.seqNo);
			}
			this.$apiClient
				.getInstance()
				.post(this.$apiClient.getApiServer() + '/api/common/getGroupByBusinessYearList.do', formData)
				.then(res => {
					if (res.data.resultCode === 0) {
						this.groupByBusinessYearList = res.data.data;
					} else {
						window.alert(res.data.resultMsg);
					}
				})
				.catch(e => console.error(e));
		},
		getBusinessYearByTpList: function() {
			this.businessYearByTpList = [];
			this.businessTp = '';
			let formData = new FormData();
			if (this.loginMember.budsUserType === CONST.USER_TYPE.COMPANY) {
				formData.append('companySeqNo', this.loginMember.seqNo);
			} else {
				formData.append('userSeqNo', this.loginMember.seqNo);
			}
			// formData.append('businessYear', this.businessYear);
			this.$apiClient
				.getInstance()
				.post(this.$apiClient.getApiServer() + '/api/common/getBusinessYearByTpList.do', formData)
				.then(res => {
					if (res.data.resultCode === 0) {
						this.businessYearByTpList = res.data.data;
					} else {
						window.alert(res.data.resultMsg);
					}
				})
				.catch(e => console.error(e));
		},
		getGroupByCountryList: function() {
			this.countryList = [];
			let formData = new FormData();
			// formData.append('contiSeqNo', this.contiSeqNo);
			if (this.loginMember.budsUserType === CONST.USER_TYPE.COMPANY) {
				formData.append('companySeqNo', this.loginMember.seqNo);
			} else {
				formData.append('userSeqNo', this.loginMember.seqNo);
			}
			formData.append('businessYear', this.businessYear);
			this.$apiClient
				.getInstance()
				.post(this.$apiClient.getApiServer() + '/api/business/getGroupByCountryList.do', formData)
				.then(res => {
					if (res.data.resultCode === 0) {
						this.countryList = res.data.data;
					} else {
						window.alert(res.data.resultMsg);
					}
				})
				.catch(e => console.error(e));
		},
		getGroupByRegionList: function() {
			this.regionList = [];
			this.region = '';
			let formData = new FormData();
			formData.append('country', this.country);
			this.$apiClient
				.getInstance()
				.post(this.$apiClient.getApiServer() + '/api/business/getGroupByRegionList.do', formData)
				.then(res => {
					if (res.data.resultCode === 0) {
						this.regionList = res.data.data;
					} else {
						window.alert(res.data.resultMsg);
					}
				})
				.catch(e => console.error(e));
		},
		// 리스트 불러오기
		getBusinessList: function() {
			this.businessList = [];
			this.totalCount = 0;
			let formData = new FormData();
			if (this.loginMember.budsUserType === CONST.USER_TYPE.COMPANY) {
				formData.append('companySeqNo', this.loginMember.seqNo);
			} else {
				formData.append('userSeqNo', this.loginMember.seqNo);
			}
			formData.append('keyword', this.keyword);
			formData.append('page', this.listPage);
			formData.append('row', this.listPageRow);
			formData.append('businessTp', this.businessTp);
			formData.append('businessYear', this.businessYear);
			formData.append('country', this.country);
			formData.append('region', this.region);
			this.$apiClient
				.getInstance()
				.post(this.$apiClient.getApiServer() + '/api/business/getBusinessList.do', formData)
				.then(res => {
					if (res.data.resultCode !== 0) {
						window.alert(res.data.resultMsg);
					} else {
						this.businessList = res.data.data;
						if (this.businessList.length > 0) {
							for (let i = 0; i < this.businessList.length; i++) {
								this.businessList[i].agreementStartDate = moment(this.businessList[i].agreementStartDate).tz('Asia/Seoul');
								this.businessList[i].agreementEndDate = moment(this.businessList[i].agreementEndDate).tz('Asia/Seoul');
							}
						}
						this.totalCount = res.data.dataCount;
					}
				})
				.catch(e => {
					console.error(e);
					window.alert(e.message);
				});
		},
	},
};
</script>
<style scoped></style>
